export default "__VITE_ASSET__e2da7669__"